import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { readTranslations } from "../Api";

i18n
    .use(initReactI18next)
    .init({
        partialBundledLanguages: true,
        lng: localStorage.getItem("NG_TRANSLATE_LANG_KEY") ?? '',
        ns: ['translations'],
        interpolation: {
            escapeValue: false
        },
        resources: {}
    });

export default i18n;

export async function initializeTranslations() {
    const languageKey = localStorage.getItem("NG_TRANSLATE_LANG_KEY");

    await readTranslations().then((resource) => {
        i18n.addResourceBundle(languageKey ?? '', 'translations', resource);
    });
}

